import type { init } from "@sentry/react";

type SentryInitOptions = Parameters<typeof init>[0];
type TransactionEvent = Parameters<
  NonNullable<SentryInitOptions["beforeSendTransaction"]>
>[0];
type TransactionName = TransactionEvent["transaction"];

export const shouldDropForgotTransaction = (
  transactionName: TransactionName | undefined
) => {
  if (!transactionName) return false;
  return (
    transactionName.includes("/auth/forgot") ||
    transactionName.includes("/authorization/forgot")
  );
};

export const hasForgotSpan = (event: TransactionEvent) => {
  const spans = event.spans ?? [];
  return spans.some((span) => {
    const dataUrl =
      typeof (span.data as { url?: unknown } | undefined)?.url === "string"
        ? (span.data as { url: string }).url
        : undefined;
    const description =
      typeof span.description === "string" ? span.description : "";
    return (
      dataUrl?.includes("/authorization/forgot") ||
      description.includes("/authorization/forgot")
    );
  });
};
